import React from "react";
import uiPrefix from "../utils/UiPrefixUtils";
import styles from "./StageContainer.module.css";

const StageContainer = ({ children }) => (
  <div className={styles["stage-container"]} data-e2e={uiPrefix("stage-container")}>
    {children}
  </div>
);

export default StageContainer;
